import locationsData from "./locations.json";

export const countryOptions = locationsData.countries.map((e) => ({
  label: e.name,
  value: e.name,
}));

export const stateOptions = locationsData.states.map((e) => ({
  value: e,
  label: e,
}));
